import axios from "axios";
let token = '';
if (localStorage.getItem('user')) {
    token = JSON.parse(localStorage.getItem('user'))['api_token'];
}

export const getIDTypeService = () => {
    return axios.get(`${process.env.REACT_APP_API_URL}/tipo_documentos?api_token=${token}`)
}